import { render, staticRenderFns } from "./showIpfcEmails.vue?vue&type=template&id=226bf3e9"
import script from "./showIpfcEmails.vue?vue&type=script&lang=js"
export * from "./showIpfcEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports